import { render } from "./IdentityDocuments.vue?vue&type=template&id=7487f812"
import script from "./IdentityDocuments.vue?vue&type=script&lang=js"
export * from "./IdentityDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__